import { FC } from "react";
import { Checkbox, FormControl, FormControlProps } from "@mui/material";
import { Controller } from "react-hook-form";
import { ControllerProps } from "react-hook-form";
import CustomLabelInput from "@components/CustomLabelInput";

interface ReactHookFormCheckboxProps extends FormControlProps {
  label: string;
  controller: Omit<ControllerProps<any>, "render">;
}

const ReactHookFormCheckbox: FC<ReactHookFormCheckboxProps> = ({
  label,
  controller,
  ...props
}) => {
  const labelId = `${controller.name}-label`;
  return (
    <CustomLabelInput label={label} labelId={labelId}>
      <FormControl {...props}>
        <Controller
          render={({ field }) => (
            <Checkbox
              {...field}
              defaultValue={controller.defaultValue}
              checked={field.value}
            />
          )}
          {...controller}
        />
      </FormControl>
    </CustomLabelInput>
  );
};

export default ReactHookFormCheckbox;
